import {PredefinedBaseConfiguration} from './PredefinedBaseConfiguration';

export class ContextDataDecisionConfiguration extends PredefinedBaseConfiguration {
code: string;
exists: boolean | null;
kind: string;
}

